export { Legal } from './Legal';
